module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('main', {
    staticClass: "content"
  }, [_vm._m(0), _vm._v(" "), _c('form', {
    staticClass: "form",
    attrs: {
      "action": ""
    }
  }, [(_vm.errorMessage) ? _c('Message', {
    attrs: {
      "message-content": _vm.errorMessage,
      "message-status": "error"
    }
  }) : _vm._e(), _vm._v(" "), _c('fieldset', {
    staticClass: "form--item"
  }, [_c('label', {
    staticClass: "label",
    attrs: {
      "for": ""
    }
  }, [_vm._v("\n                Name:\n            ")]), _vm._v(" "), _c('div', {
    staticClass: "input_text"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.wall.name),
      expression: "wall.name"
    }],
    attrs: {
      "name": "",
      "placeholder": "Write a wall name",
      "type": "text",
      "value": "Bowers & Houston St"
    },
    domProps: {
      "value": (_vm.wall.name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.wall, "name", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('fieldset', {
    staticClass: "form--item"
  }, [_c('label', {
    staticClass: "label",
    attrs: {
      "for": ""
    }
  }, [_vm._v("\n                City:\n            ")]), _vm._v(" "), _c('div', {
    staticClass: "input_text"
  }, [_c('v-select', {
    attrs: {
      "required": "",
      "searchable": false,
      "placeholder": "Choose a city",
      "options": _vm.cities
    },
    model: {
      value: (_vm.cityId),
      callback: function($$v) {
        _vm.cityId = $$v
      },
      expression: "cityId"
    }
  })], 1)]), _vm._v(" "), _c('fieldset', {
    staticClass: "form--item"
  }, [_c('label', {
    staticClass: "label",
    attrs: {
      "for": ""
    }
  }, [_vm._v("\n                Address:\n            ")]), _vm._v(" "), _c('div', {
    staticClass: "input_text"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.wall.address),
      expression: "wall.address"
    }],
    attrs: {
      "name": "",
      "placeholder": "Write an address",
      "type": "text",
      "value": "294 Bowery"
    },
    domProps: {
      "value": (_vm.wall.address)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.wall, "address", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('fieldset', {
    staticClass: "form--item"
  }, [_c('label', {
    staticClass: "label",
    attrs: {
      "for": ""
    }
  }, [_vm._v("\n                Zip code:\n            ")]), _vm._v(" "), _c('div', {
    staticClass: "input_text"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.wall.zipcode),
      expression: "wall.zipcode"
    }],
    attrs: {
      "name": "",
      "placeholder": "Write a zip code",
      "type": "text",
      "value": "10012"
    },
    domProps: {
      "value": (_vm.wall.zipcode)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.wall, "zipcode", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('fieldset', {
    staticClass: "form--item"
  }, [_c('label', {
    staticClass: "label",
    attrs: {
      "for": ""
    }
  }, [_vm._v("\n                Agent email address:\n            ")]), _vm._v(" "), _c('div', {
    staticClass: "input_text"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.agentEmail),
      expression: "agentEmail"
    }],
    attrs: {
      "name": "",
      "placeholder": "Write an email address",
      "type": "text"
    },
    domProps: {
      "value": (_vm.agentEmail)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.agentEmail = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('fieldset', {
    staticClass: "form--item"
  }, [_c('label', {
    staticClass: "label",
    attrs: {
      "for": "picture"
    }
  }, [_vm._v("\n                Picture:\n            ")]), _vm._v(" "), _c('div', {
    staticClass: "form--item_img-wrapper"
  }, [_c('div', {
    staticClass: "form--item_img",
    attrs: {
      "id": "preview_image"
    }
  }), _vm._v(" "), _c('label', {
    staticClass: "input_file",
    attrs: {
      "for": "picture",
      "id": "picture_choose"
    }
  }, [_c('span', {
    staticClass: "btn btn_grey"
  }, [_vm._v("\n                      Choose file\n                  ")]), _vm._v(" "), _c('input', {
    attrs: {
      "required": "",
      "id": "picture",
      "name": "picture",
      "type": "file"
    },
    on: {
      "change": _vm.setPicture
    }
  })])])]), _vm._v(" "), _c('fieldset', {
    staticClass: "form--item"
  }, [_c('label', {
    staticClass: "label",
    attrs: {
      "for": ""
    }
  }, [_vm._v("\n                About Wall:\n            ")]), _vm._v(" "), _c('div', {
    staticClass: "input_text input_text_long"
  }, [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.wall.wallDescription),
      expression: "wall.wallDescription"
    }],
    attrs: {
      "name": "",
      "placeholder": "Write a zip code",
      "type": "text",
      "value": "Located at one of the busiest downtown intersections in Manhattan, this is truly an iconic wall. Surrounded by hip hotels, restaurants, galleries, and other stylish retail, it boasts a projection screen area of about 70x35’ (22x11m). It is available year-round"
    },
    domProps: {
      "value": (_vm.wall.wallDescription)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.wall, "wallDescription", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('fieldset', {
    staticClass: "form--item"
  }, [_c('label', {
    staticClass: "label",
    attrs: {
      "for": ""
    }
  }, [_vm._v("\n                Add Wall Location pin:\n            ")]), _vm._v(" "), _c('div', {
    staticClass: "location--wrapper"
  }, [_c('gmap-map', {
    staticStyle: {
      "width": "500px",
      "height": "300px"
    },
    attrs: {
      "center": _vm.wall.location,
      "zoom": 16,
      "map-type-id": "terrain"
    }
  }, [_c('gmap-marker', {
    attrs: {
      "position": _vm.wall.location,
      "clickable": true,
      "draggable": true,
      "icon": 'static/images/gm_pin.png'
    },
    on: {
      "dragend": function($event) {
        _vm.dragend($event)
      }
    }
  })], 1)], 1)]), _vm._v(" "), _c('fieldset', {
    staticClass: "form--item"
  }, [_c('label', {
    staticClass: "label",
    attrs: {
      "for": ""
    }
  }, [_vm._v("\n                Create new password\n            ")]), _vm._v(" "), _c('div', {
    staticClass: "input_text"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.wall.password),
      expression: "wall.password"
    }],
    attrs: {
      "name": "",
      "placeholder": "Choose a password",
      "type": "password",
      "value": "WalltimeisDope2017"
    },
    domProps: {
      "value": (_vm.wall.password)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.wall, "password", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('fieldset', {
    staticClass: "form--item"
  }, [_c('label', {
    staticClass: "label",
    attrs: {
      "for": ""
    }
  }, [_vm._v("\n                Screen saver:\n            ")]), _vm._v(" "), _c('div', {
    staticClass: "input_text"
  }, [_c('v-select', {
    attrs: {
      "required": "",
      "searchable": false,
      "placeholder": "Pick a screensaver",
      "options": _vm.screensavers
    },
    model: {
      value: (_vm.screensaverId),
      callback: function($$v) {
        _vm.screensaverId = $$v
      },
      expression: "screensaverId"
    }
  })], 1)]), _vm._v(" "), _c('fieldset', {
    staticClass: "form--item"
  }, [_c('label', {
    staticClass: "label",
    attrs: {
      "for": ""
    }
  }, [_vm._v("\n                Webcams:\n            ")]), _vm._v(" "), _c('div', {
    staticClass: "inputGroup"
  }, [_c('label', {
    staticClass: "inputGroup--label",
    attrs: {
      "for": "input8"
    }
  }, [_vm._v("\n                    Webcam 1\n                ")]), _vm._v(" "), _c('div', {
    staticClass: "input_text"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.webcam_1),
      expression: "webcam_1"
    }],
    attrs: {
      "id": "input8",
      "name": "",
      "placeholder": "Paste a URL link from Ustream",
      "type": "text",
      "value": "http://ustream/58ae17c50119028a1e16a7d4"
    },
    domProps: {
      "value": (_vm.webcam_1)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.webcam_1 = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "inputGroup"
  }, [_c('label', {
    staticClass: "inputGroup--label",
    attrs: {
      "for": "input9"
    }
  }, [_vm._v("\n                    Webcam 2\n                ")]), _vm._v(" "), _c('div', {
    staticClass: "input_text"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.webcam_2),
      expression: "webcam_2"
    }],
    attrs: {
      "id": "input9",
      "name": "",
      "placeholder": "Paste a URL link from Ustream",
      "type": "text",
      "value": ""
    },
    domProps: {
      "value": (_vm.webcam_2)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.webcam_2 = $event.target.value
      }
    }
  })])])]), _vm._v(" "), _c('fieldset', {
    staticClass: "form--item"
  }, [_c('label', {
    staticClass: "label",
    attrs: {
      "for": ""
    }
  }, [_vm._v("\n                Basis price per 6 seconds:\n            ")]), _vm._v(" "), _c('div', {
    staticClass: "input_text"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.wall.basePricing),
      expression: "wall.basePricing"
    }],
    attrs: {
      "name": "",
      "placeholder": "1$",
      "type": "text",
      "value": ""
    },
    domProps: {
      "value": (_vm.wall.basePricing)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.wall, "basePricing", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('fieldset', {
    staticClass: "form--item"
  }, [_vm._m(1), _vm._v(" "), _vm._l((_vm.wall.pricingModifiers), function(block) {
    return _c('div', [_c('div', {
      staticClass: "input_text"
    }, [_c('input', {
      attrs: {
        "name": "",
        "type": "text"
      },
      domProps: {
        "value": _vm.formatPriceBlock(block)
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "row7"
    }, [_c('a', {
      staticClass: "btn btn_half btn_blueLight u-fleft",
      on: {
        "click": function($event) {
          _vm.editPriceBlock(block)
        }
      }
    }, [_vm._v("\n                      Edit\n                  ")]), _vm._v(" "), _c('a', {
      staticClass: "btn btn_half btn_red u-fleft",
      on: {
        "click": function($event) {
          _vm.deletePriceBlock(block)
        }
      }
    }, [_vm._v("\n                      Delete\n                  ")])])])
  }), _vm._v(" "), _c('div', {
    staticClass: "row7"
  }, [_c('a', {
    staticClass: "btn row7--add u-fleft",
    on: {
      "click": function($event) {
        _vm.togglePriceBlock()
      }
    }
  }, [_vm._v("\n                    Add new pricing block\n                ")])])], 2), _vm._v(" "), _c('fieldset', {
    staticClass: "form--item divider"
  }, [_c('label', {
    staticClass: "label",
    attrs: {
      "for": ""
    }
  }, [_vm._v("\n                Recurring blocked timeslots:\n            ")]), _vm._v(" "), _vm._l((_vm.wall.recurringBlockedTimeslots), function(block) {
    return _c('div', [_c('div', {
      staticClass: "input_text"
    }, [_c('input', {
      staticClass: "pointer",
      attrs: {
        "name": "",
        "type": "text",
        "readonly": "true"
      },
      domProps: {
        "value": block.formatted_value
      },
      on: {
        "click": function($event) {
          _vm.editRecurringBlockedTimeslotBlock(block)
        }
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "row7"
    }, [_c('button', {
      staticClass: "btn btn_half btn_blueLight u-fleft",
      attrs: {
        "type": "button"
      },
      on: {
        "click": function($event) {
          _vm.editRecurringBlockedTimeslotBlock(block)
        }
      }
    }, [_vm._v("\n                      Edit\n                  ")]), _vm._v(" "), _c('button', {
      staticClass: "btn btn_half btn_red u-fleft",
      attrs: {
        "type": "button"
      },
      on: {
        "click": function($event) {
          _vm.deleteRecurringBlockedTimeslotBlock(block)
        }
      }
    }, [_vm._v("\n                      Delete\n                  ")])])])
  }), _vm._v(" "), _c('div', {
    staticClass: "row7"
  }, [_c('button', {
    staticClass: "btn row7--add u-fleft",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.toggleRecurringBlockedTimeslotBlock()
      }
    }
  }, [_vm._v("\n                    Add new recurring blocked timeslot\n                ")])])], 2), _vm._v(" "), _c('div', {
    staticClass: "row7"
  }, [_c('a', {
    staticClass: "btn btn_half btn_green u-fleft u-mr1",
    on: {
      "click": function($event) {
        _vm.updateWall()
      }
    }
  }, [_vm._v("\n                Update\n            ")]), _vm._v(" "), _c('a', {
    staticClass: "btn btn_half btn_red u-fleft",
    on: {
      "click": function($event) {
        _vm.confirmToggle()
      }
    }
  }, [_vm._v("\n                Delete\n            ")])])], 1), _vm._v(" "), _c('confirm', {
    attrs: {
      "resource": "wall",
      "visible": _vm.alertVisible
    },
    on: {
      "update:visible": function($event) {
        _vm.alertVisible = $event
      }
    }
  }), _vm._v(" "), _c('ok', {
    attrs: {
      "resource": "wall",
      "resource-plural": "walls",
      "visible": _vm.okVisible
    },
    on: {
      "update:visible": function($event) {
        _vm.okVisible = $event
      }
    }
  }), _vm._v(" "), _c('price', {
    attrs: {
      "visible": _vm.priceVisible,
      "block": _vm.block
    },
    on: {
      "update:visible": function($event) {
        _vm.priceVisible = $event
      }
    }
  }), _vm._v(" "), _c('recurringBlockedTimeslot', {
    attrs: {
      "visible": _vm.recurringBlockedTimeslotVisible,
      "block": _vm.block
    },
    on: {
      "update:visible": function($event) {
        _vm.recurringBlockedTimeslotVisible = $event
      }
    }
  }), _vm._v(" "), _c('loading', {
    attrs: {
      "visible": _vm.loadingVisible
    },
    on: {
      "update:visible": function($event) {
        _vm.loadingVisible = $event
      }
    }
  })], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row"
  }, [_c('h1', [_vm._v("\n            Edit Wall\n        ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', {
    staticClass: "label",
    attrs: {
      "for": ""
    }
  }, [_vm._v("\n                Princing blocks:\n                "), _c('span', [_vm._v("\n                    (Any timeslot which is not covered will apply the basis price).\n                ")])])
}]}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-1ec92bc4", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1ec92bc4","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Walls/EditWalls.vue
// module id = 426
// module chunks = 1